import { createThunklessAction } from 'thunkless';

import { avo } from '@/api/app/avo-client';

export enum ReferralTypes {
  GET_REFERRAL_CODE_REQUEST = 'app/referrals/GET_REFERRAL_CODE_REQUEST',
  GET_REFERRAL_CODE_SUCCESS = 'app/referrals/GET_REFERRAL_CODE_SUCCESS',
  GET_REFERRAL_CODE_FAILURE = 'app/referrals/GET_REFERRAL_CODE_FAILURE',
  GENERATE_REFERRAL_CODE_REQUEST = 'app/referrals/GENERATE_REFERRAL_CODE_REQUEST',
  GENERATE_REFERRAL_CODE_SUCCESS = 'app/referrals/GENERATE_REFERRAL_CODE_SUCCESS',
  GENERATE_REFERRAL_CODE_FAILURE = 'app/referrals/GENERATE_REFERRAL_CODE_FAILURE',
  GET_REFERRALS_REQUEST = 'app/referrals/GET_REFERRALS_REQUEST',
  GET_REFERRALS_SUCCESS = 'app/referrals/GET_REFERRALS_SUCCESS',
  GET_REFERRALS_FAILURE = 'app/referrals/GET_REFERRALS_FAILURE',
}

export interface SubdomainProps {
  subdomain: string;
}

export const getReferralCode = ({ subdomain }: SubdomainProps) => createThunklessAction({
  type: [
    ReferralTypes.GET_REFERRAL_CODE_REQUEST,
    ReferralTypes.GET_REFERRAL_CODE_SUCCESS,
    ReferralTypes.GET_REFERRAL_CODE_FAILURE,
  ] as const,
  promise: () => avo.ajax({
    method: 'GET',
    route: `/accounts/${subdomain}/referral_code`,
  }),
});

export const generateReferralCode = ({ subdomain }: SubdomainProps) => createThunklessAction({
  type: [
    ReferralTypes.GENERATE_REFERRAL_CODE_REQUEST,
    ReferralTypes.GENERATE_REFERRAL_CODE_SUCCESS,
    ReferralTypes.GENERATE_REFERRAL_CODE_FAILURE,
  ] as const,
  promise: () => avo.ajax({
    method: 'POST',
    route: `/accounts/${subdomain}/referral_code`,
    payload: { react_request: true },
  }),
});

export const getReferrals = ({ subdomain }: SubdomainProps) => createThunklessAction({
  type: [
    ReferralTypes.GET_REFERRALS_REQUEST,
    ReferralTypes.GET_REFERRALS_SUCCESS,
    ReferralTypes.GET_REFERRALS_FAILURE,
  ] as const,
  promise: () => avo.ajax({
    method: 'GET',
    route: `/accounts/${subdomain}/referrals`,
  }),
});
